import React from "react";
import Button from "./button";

function ImagesEditor({ images, onChange, uploadImageFn, accept = "image/*" }) {
  const fileInputRef = React.useRef(null);

  const handleAddClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
      fileInputRef.current.click();
    }
  };

  const handleFileChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    try {
      const newUrl = await uploadImageFn(file);
      onChange([...images, newUrl]);
    } catch (_error) {
      alert("Could not upload image");
    }
  };

  const removeImage = (index) => {
    const updated = [...images];
    updated.splice(index, 1);
    onChange(updated);
  };

  const moveImageUp = (index) => {
    if (index === 0) return;
    const updated = [...images];
    [updated[index - 1], updated[index]] = [updated[index], updated[index - 1]];
    onChange(updated);
  };

  const moveImageDown = (index) => {
    if (index === images.length - 1) return;
    const updated = [...images];
    [updated[index + 1], updated[index]] = [updated[index], updated[index + 1]];
    onChange(updated);
  };

  return (
    <div className="mb-4">
      <h3 className="text-xl font-bold mb-4">Bilder</h3>
      <input
        type="file"
        accept={accept}
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={handleFileChange}
      />

      <p className="text-sm text-text-muted mb-2">
        Första bilden (överst) används som <strong>primär bild</strong>.
      </p>

      {images.map((imageUrl, index) => (
        <div key={index} className="flex items-center gap-4 mb-4">
          <img src={imageUrl} alt={`Preview ${index}`} className="w-48 h-48 object-cover border" />
          <div className="flex flex-col gap-2">
            <div className="flex gap-2">
              <Button onClick={() => moveImageUp(index)} disabled={index === 0}>
                ⬆
              </Button>
              <Button onClick={() => moveImageDown(index)} disabled={index === images.length - 1}>
                ⬇
              </Button>
            </div>
            <Button onClick={() => removeImage(index)}>Ta bort</Button>
          </div>
        </div>
      ))}

      <p className="text-sm text-text-muted mb-2">
        Bilder över 1 MB optimeras automatiskt före uppladdning.
      </p>

      <div className="flex gap-4 mt-4">
        <Button onClick={handleAddClick}>Lägg till ny bild</Button>
      </div>
    </div>
  );
}

export default ImagesEditor;
